export enum LineItemType {
    Data = "Data",
    Comment = "Comment",
}
